import { render, staticRenderFns } from "./SocialBox.vue?vue&type=template&id=8b05962a&"
import script from "./SocialBox.vue?vue&type=script&lang=ts&"
export * from "./SocialBox.vue?vue&type=script&lang=ts&"
import style0 from "./SocialBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports